
import Button from '~/components/atoms/Button.vue'
export default {
  name: 'EmptyProducts',
  components: {
    Button,
  },
  data: () => ({}),
  methods: {
    clearFilters() {
      this.$router.push({
        path: this.$route.path,
        params: undefined,
      })
    },
  },
}
